// Recovered compiled webpack factory 15657. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "default", {
      enumerable: !0,
      get: function () {
        return o;
      },
    }),
    r(28140));
  let n = r(95155);
  r(12115);
  let a = r(73360);
  function o(e) {
    function t(t) {
      return (0, n.jsx)(e, { router: (0, a.useRouter)(), ...t });
    }
    return (
      (t.getInitialProps = e.getInitialProps),
      (t.origGetInitialProps = e.origGetInitialProps),
      t
    );
  }
  ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
    void 0 === t.default.__esModule &&
    (Object.defineProperty(t.default, "__esModule", { value: !0 }),
    Object.assign(t.default, t),
    (e.exports = t.default));
}
